import type { WorkflowDefinition } from './types';
import { config } from '@/config';

export const WORKFLOW_DEFINITIONS: Record<string, WorkflowDefinition> = {
  onboarding: {
    id: 'onboarding',
    title: `Get Started with ${config.appFullName}`,
    description: 'Complete these steps to start monitoring your network',
    scope: 'organization',
    steps: [
      {
        id: 'rename_organization',
        title: 'Name your organization',
        description: 'Customize your organization name',
        path: '/admin/general',
      },
      {
        id: 'create_division',
        title: 'Create a division',
        description: 'Organize your network by location or department',
        path: '/admin/divisions',
        optional: true,
      },
      {
        id: 'add_gateway',
        title: 'Add a gateway',
        description: 'Add a gateway to start collecting information from your network',
        path: '/gateways',
      },
      {
        id: 'add_credential',
        title: 'Add SNMP credentials',
        description: 'Set up credentials for device access',
        path: '/credentials',
      },
      {
        id: 'add_device',
        title: 'Add your first device',
        description: 'Start monitoring a network device',
        path: '/network?tab=equipment',
      },
    ],
  },
  'user-setup': {
    id: 'user-setup',
    title: 'Complete Your Profile',
    description: 'Personalize your account',
    scope: 'user',
    steps: [
      {
        id: 'set_display_name',
        title: 'Set your display name',
        description: 'How others will see you',
        path: '/account/profile',
      },
    ],
  },
};

export function getWorkflowDefinition(workflowId: string): WorkflowDefinition | undefined {
  return WORKFLOW_DEFINITIONS[workflowId];
}
